import Title from '@/components/InspectionReport/Items/Questions/Title';
import Response from '@/components/InspectionReport/Items/Questions/Response';

export default {
    functional: true,
    props: {
        item: {
            type: Object,
            required: true,
        },
        resource: {
            type: Object,
            default: null,
        },
    },
    render(h, { props, data }) {
        return h(
            'div',
            data,
            [
                h(Title, {}, props.item.title),
                h(Response, { props: { responded: props.item.responded === true } }, props.item.response),
            ],
        );
    },
};
